import { render, staticRenderFns } from "./WorkflowTemplateList.vue?vue&type=template&id=667e0e6c"
import script from "./WorkflowTemplateList.vue?vue&type=script&lang=js"
export * from "./WorkflowTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports